// src/submit-icon.tsx
import { createSvgIcon } from "@mui/material";
import { jsx } from "react/jsx-runtime";
var SubmitIcon = createSvgIcon(
  /* @__PURE__ */ jsx("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx(
    "path",
    {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "2",
      stroke: "currentColor",
      fill: "transparent",
      d: "M12.559 12.002H6.477m-.172.798L5.3 15.8c-.55 1.644-.825 2.466-.628 2.972.172.44.54.773.994.9.524.146 1.314-.21 2.895-.921l10.134-4.561c1.543-.694 2.315-1.042 2.553-1.524a1.5 1.5 0 0 0 0-1.33c-.238-.482-1.01-.829-2.553-1.523L8.543 5.245c-1.576-.709-2.364-1.063-2.886-.918a1.5 1.5 0 0 0-.995.898c-.198.505.074 1.325.619 2.965l1.026 3.092c.093.281.14.422.159.566a1.5 1.5 0 0 1 0 .385c-.02.144-.067.285-.161.567Z"
    }
  ) }),
  "SubmitIcon"
);

export {
  SubmitIcon
};
